import axios from 'axios';

export const get3DBlock = async (blockId) => axios.get(`/api/data/3d/block/${blockId}/`);
export const get3DBlockDateRange = async (blockId, startDate, endDate) =>
  axios.get(`/api/data/3d/?block=${blockId}&startDate=${startDate}&endDate=${endDate}/`);

export const getBlockRootzoneVWCGraph = async ({ blockId, startDate, endDate }) => {
  return axios.get(`/api/block/rootzone-vwc-graph/?block=${blockId}&startDate=${startDate}&endDate=${endDate}`);
}

export const getBlockAnomaly = async (blockId) => {
  return axios.get(`/api/anomaly/block/${blockId}/`);
}

export const requestImagingServices = async () => {
  return axios.post('/api/user/request/imaging/services/');
}

export const anomalyErrorReport = async (errorObj) => {
  return axios.post('/api/jira/anomaly/error/report/', errorObj);
}

export const softDeleteAnomaly = async (deleteObj) => {
  return axios.post(`https://map2.farmx.co/api/anomalyexclusion/create/`, deleteObj);
}

export const createAnomaly = async (anomaly) => {
  return axios.post(`/api/anomaly/create/`, anomaly);
}

export const updateAnomaly = async (anomaly) => {
  return axios.put(`/api/anomaly/edit/${anomaly.id}/`, anomaly);
}

export const deleteAnomaly = async (anomalyId) => {
  return axios.delete(`/api/anomaly/edit/${anomalyId}/`);
}

export const getAnomalyComments = async (anomalyId) => {
  return axios.get(`/api/anomaly/${anomalyId}/comment/`);
}

export const createAnomalyComment = async (anomalyCommentData) => {
  return axios.post('/api/anomaly/comment/create/', anomalyCommentData);
};

export const updateAnomalyComment = async (commentId, anomalyCommentData) => {
  return axios.patch(`/api/anomaly/comment/edit/${commentId}/`, anomalyCommentData);
};

export const deleteAnomalyComment = async (commentId) => {
  return axios.delete(`/api/anomaly/comment/edit/${commentId}/`);
};
